"use client";

import { Theme } from "@packages/sdk";
import { useContext, useEffect, useState } from "react";

import { themeContext } from "./themeContext";

type CurrentTheme = Theme.Dark | Theme.Light;
export const useTheme = () => {
  const {
    setTheme,
    theme,
    themeContainerRef,
    fontStyle,
    setFontStyle,
    letterSpacing,
    setLetterSpacing,
    wordSpacing,
    setWordSpacing,
  } = useContext(themeContext);

  const getCurrentTheme = (
    theme: Theme,
    isSystemDark: boolean,
  ): CurrentTheme => {
    return theme === Theme.Match
      ? isSystemDark
        ? Theme.Dark
        : Theme.Light
      : theme;
  };
  const [currentTheme, setCurrentTheme] = useState(Theme.Light);

  const toggleTheme = () =>
    setTheme(theme === Theme.Dark ? Theme.Light : Theme.Dark);

  useEffect(() => {
    if (!window) return;
    const darkModeMatch = window.matchMedia("(prefers-color-scheme: dark)");
    setCurrentTheme(getCurrentTheme(theme, darkModeMatch.matches));
    darkModeMatch.onchange = (event) => {
      setCurrentTheme(getCurrentTheme(theme, event.matches));
    };
  }, [theme]);

  return {
    setTheme,
    theme,
    themeContainerRef,
    currentTheme,
    toggleTheme,
    fontStyle,
    setFontStyle,
    letterSpacing,
    setLetterSpacing,
    wordSpacing,
    setWordSpacing,
  };
};
